import { createApp } from "vue";
import { store } from "./store";
import { configure } from "vee-validate";
import VCalendar from "v-calendar";
import "bootstrap/dist/css/bootstrap.css";
import "vue-select/dist/vue-select.css";
import "./assets/sass/main.scss";
import 'v-calendar/style.css';
import App from "./App.vue";
import VueSelect from "vue-select";
import router from "./routes/routes";
import * as globalValidators from "./plugins/globalValidatiors";
import clickOutside from "./directives/click-ouside.js";
import onBlur from "./directives/on-blur.js";
import test from "./directives/test.js";
const app = createApp({
  extends: App,
  created() {
    if (JSON.parse(localStorage.getItem("vue-session-key"))?.data) {
      //extractSessionData()
    }
  },
  beforeCreate() {
    if (!localStorage.getItem("vue-session-key")) {
      localStorage.setItem("vue-session-key", JSON.stringify({ data: {} }));
    }
  }
});

configure({
  validateOnInput: true
});
app.directive("click-outside", clickOutside);
app.directive("on-blur", onBlur);
app.directive("test", test);
app.use(router);
app.use(store);
app.use(VCalendar, {});
app.use(globalValidators);
app.component("v-select", VueSelect);
app.mount("#app");
